import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import {
	FeedBackMetrics,
	FeedbackMetricsRequest,
	HttpResponse,
} from '@/interfaces';

class FeedbackService {
	constructor(private client: AxiosInstance) {}

	async get() {
		return this.client.get(`/feedback?page=1&limit=10`);
	}

	async getByUserId(userId: string) {
		return this.client.get(`/feedback/${userId}`);
	}

	async getMetrics({
		page,
		date,
		nps,
		csat,
		cityId,
		stateId,
		caseStatus,
		retention,
		activeUsers,
		responseRate,
		segmentationId,
	}: FeedbackMetricsRequest): Promise<HttpResponse<FeedBackMetrics>> {
		const params = {
			page,
			...(nps && { nps }),
			...(csat && { csat }),
			...(cityId && { cityId }),
			...(stateId && { stateId }),
			...(date && { date: date.toUpperCase() }),
			...(caseStatus && { caseStatus: caseStatus.toUpperCase() }),
			...(retention && { retention: retention.toUpperCase() }),
			...(activeUsers && { activeUsers: activeUsers === 'yes' }),
			...(responseRate && { responseRate: responseRate.toUpperCase() }),
			...(segmentationId && { segmentationId }),
		};
		return this.client.get(`/metrics/feedback`, { params });
	}

	async post({
		probabilityOfRecommendation,
		rate,
		reason,
	}: {
		probabilityOfRecommendation: number;
		rate: number;
		reason: string;
	}): Promise<HttpResponse<void>> {
		return this.client.post(`/feedback`, {
			probabilityOfRecommendation,
			rate,
			reason,
		});
	}

	async downloadExcel({
		page,
		date,
		nps,
		csat,
		cityId,
		stateId,
		caseStatus,
		retention,
		activeUsers,
		responseRate,
		segmentationId,
	}: FeedbackMetricsRequest) {
		const params = {
			page,
			limit: 100,
			...(nps && { nps }),
			...(csat && { csat }),
			...(cityId && { cityId }),
			...(stateId && { stateId }),
			...(date && { date: date.toUpperCase() }),
			...(caseStatus && { caseStatus: caseStatus.toUpperCase() }),
			...(retention && { retention: retention.toUpperCase() }),
			...(activeUsers && { activeUsers: activeUsers === 'yes' }),
			...(responseRate && { responseRate: responseRate.toUpperCase() }),
			...(segmentationId && { segmentationId }),
		};

		return this.client.get(`/metrics/feedback/excel`, {
			params,
			responseType: 'arraybuffer',
		});
	}
}

export const feedbackService = new FeedbackService(axiosClient);
